<template>
  <div class="content" >
    <a-table :data-source="dataList" class="wiring_table"  :row-key="(row,index)=>index" :columns="columns" v-bind="tableAttribute">
      <template v-for="(item) in columns" :slot="item.dataIndex" slot-scope="text,row,index">
        <template v-if="item.scopedSlots.customRender&&item.dataIndex!==renderType.action" >
         <a-form-model-item :key="item.key" :rules="EditWiringRules[item.dataIndex].RULES" :prop="`wiringList.${index}.${item.dataIndex}`">
          <component :is="componentsType[item.type]" v-if="item.type!==renderType.date&&item.scopedSlots.customRender===renderType.skuPallet" v-model="dataList[index][item.dataIndex]"  v-bind="item.prop" @change="handleSkuPalletChange(text,row,index)"></component>
          <component :is="componentsType[item.type]" v-else-if="item.type!==renderType.date" v-model="dataList[index][item.dataIndex]"  v-bind="item.prop" @change="handleChange(text,row,index)"></component>
          <component :is="componentsType[item.type]" v-else   v-model="dataList[index][item.dataIndex]" class="my_date_input" format="YYYY-MM-DD"  v-bind="item.prop" ></component>
         </a-form-model-item>
        </template>
        <template v-else-if="item.scopedSlots.customRender===renderType.action" >
          <slot name="action" :scope="{text,row,index}"></slot>
        </template>
         <template v-else>
           <span :key="item.key">{{text}}</span>
          </template> 
      </template>
  </a-table>
  <div class="station-add startAdd">
      <a-button
        block
        type="link"
        @click="handleAdd">
        <i class="el-icon-plus"></i> {{buttonText}}
      </a-button>
  </div>
  </div>
</template>

<script>
import InputNumber from "@/components/form/InputNumber.vue";
import { EventBus } from '@/utils/event-bus'
import {EditWiringRules} from '../const'

  const componentsType={
    input:'a-input',
    numInput:'InputNumber',
    select:'a-select',
    date:'a-date-picker'
  }
  const renderType={
    action:'action',
    date:'date',
    skuPallet:'skuPallet',
  }
  export default {
    components:{
      InputNumber,
    },
    props:{
      data:{
        type:Object,
        default:()=>[]
      },
      columns:{
        type:Array,
        default:()=>[]
      },
      tableAttribute:{
        type:Object,
        default:()=>{}
      },
      buttonText:{
        type:String,
        default:()=>'添加'
      }
    },
    data(){
      return {
        componentsType,
        renderType,
        dataList:this.data.wiringList,
        form:{},
        EditWiringRules,
      }
    },
    watch:{
      data(){
        this.dataList=[...this.data.wiringList]
      }
    },
    created(){
       EventBus.$on('submit',this.handleSubmit)
    },
    methods:{
      handleAdd(){
        this.$emit('add')
      },
      handleSkuPalletChange(text,row,index){
        this.dataList[index].skuPallet=this.dataList[index].skuPallet.replace(/[^\d.]/g, '').replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        this.dataList[index].skuPalletUpper=Math.ceil(row.skuPallet)
        this.$emit('skuChange',this.dataList[index],index)
      },
      handleChange(text,row,index){
        this.dataList[index].skuPalletUpper=Math.ceil(row.skuPallet)
        this.$emit('skuChange',this.dataList[index],index)
      }
    }
  }
</script>

<style lang="less" scoped>
.content {
  padding:0 24px 32px;
  .my_date_input {
    /deep/.ant-calendar-picker-icon {
    display: none;
  }
  }
  
}
.wiring_table {
  margin-bottom: 10px;
  /deep/.ant-table-tbody {
    .ant-table-row-cell-break-word {
      padding: 8px 16px;
    }
  }
}
 .station-add {
        background: #F2FBF8;
        border: 1px dashed #06B880;
        line-height: 30px;
        &:hover {
            background: #029869;
            border: 1px dashed #029869;
            transition: all 1s;
            .ant-btn {
                color: #FFFFFF;
            }
        }
        .el-icon-plus {
          margin-right: 6px;
        }
    }
  .wiring_form{
    .ant-form-item {
      margin-bottom: 0;
    }
    /deep/.ant-input {
      width: 120px;
    }
    .my_date_input{
       width: 120px !important;
     /deep/.ant-calendar-picker-input {
       width: 120px !important;
      }
    }
  }
  
</style>